import React, { useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import * as bootstrap from 'bootstrap';
import { useAuth } from '../../context/AuthContext';
import AdminSidebarLinks from '../Sidebar/AdminSidebarLinks';
import MentorSidebarLinks from '../Sidebar/MentorSidebarLinks';
import BumdesSidebarLinks from '../Sidebar/BumdesSidebarLinks';
import DplSidebarLinks from '../Sidebar/DplSidebarLinks';

const studentMenuItems = [
  { to: '/app', icon: 'bi-grid-fill', label: 'Dashboard' },
  { to: '/app/attendances', icon: 'bi-clock-history', label: 'Kehadiran' },
  { to: '/app/publication', icon: 'bi-journal-text', label: 'Publikasi' },
  { to: '/app/capacity-building', icon: 'bi-star-fill', label: 'Capacity Building' },
  { to: '/app/bumdes/survey-veci', icon: 'bi-grid-1x2-fill', label: 'BUMDesa VECI' },
  { to: '/app/bumdes/survey-leadership', icon: 'bi-speedometer2', label: 'Survey Leadership' },
  { to: '/app/bumdes/bmc', icon: 'bi-grid-3x3-gap-fill', label: 'BUMDesa BMC' },
  { to: '/app/evaluation/pat', icon: 'bi-clipboard-check-fill', label: 'Penilaian (PAT)' },
  { to: '/app/evaluation/final', icon: 'bi-file-earmark-check-fill', label: 'Penilaian (FINAL)' },
  { to: '/app/evaluation/certificate', icon: 'bi-award-fill', label: 'Cetak Sertifikat' },
];

const MobileBottomNav = () => {
  const { authUser, signOut } = useAuth();
  const location = useLocation();
  const offcanvasRef = useRef(null);
  const offcanvasInstanceRef = useRef(null);

  const rawRole = authUser?.activeSession?.roleCode?.toLowerCase() || '';
  const role = rawRole.includes('bumdes')
    ? 'bumdes'
    : rawRole === 'dpl'
      ? 'dpl'
      : rawRole === 'admin'
        ? 'admin'
        : rawRole === 'mentor'
          ? 'mentor'
          : rawRole === 'student'
            ? 'student'
            : '';

  const isPreSurveyDone = !!authUser?.activeSession?.isPreSurveyDone;

  useEffect(() => {
    if (offcanvasInstanceRef.current) {
      offcanvasInstanceRef.current.hide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (offcanvasRef.current && !offcanvasInstanceRef.current) {
      offcanvasInstanceRef.current = new bootstrap.Offcanvas(offcanvasRef.current);
    }
  }, []);

  if (!role) {
    return null;
  }

  const openMenu = () => {
    if (!offcanvasInstanceRef.current && offcanvasRef.current) {
      offcanvasInstanceRef.current = new bootstrap.Offcanvas(offcanvasRef.current);
    }
    offcanvasInstanceRef.current?.show();
  };

  const primaryItems = {
    admin: [
      { to: '/admin', icon: 'bi-house-fill', label: 'Dashboard', end: true },
      { to: '/admin/registrations', icon: 'bi-box-arrow-in-right', label: 'Pendaftaran' },
      { to: '/admin/users', icon: 'bi-people-fill', label: 'Pengguna' },
    ],
    mentor: [
      { to: '/mentor', icon: 'bi-house-fill', label: 'Dashboard', end: true },
      { to: '/mentor/registrations', icon: 'bi-box-arrow-in-right', label: 'Pendaftaran' },
      { to: '/mentor/attendances', icon: 'bi-calendar-check', label: 'Absensi' },
    ],
    bumdes: [
      { to: '/bumdes/home', icon: 'bi-house-fill', label: 'Dashboard', end: true },
      { to: '/bumdes/pre-survey', icon: 'bi-patch-question-fill', label: 'Pre-Survey' },
      {
        to: '/bumdes/veci',
        icon: 'bi-clipboard-data-fill',
        label: 'VECI T0',
        disabled: !isPreSurveyDone,
      },
    ],
    dpl: [
      { to: '/dpl/home', icon: 'bi-house-fill', label: 'Dashboard', end: true },
      { to: '/dpl/monitoring-veci', icon: 'bi-clipboard-data-fill', label: 'Monitor VECI' },
      { to: '/dpl/monitoring-bmc', icon: 'bi-kanban-fill', label: 'Monitor BMC' },
    ],
    student: [
      { to: '/app', icon: 'bi-grid-fill', label: 'Dashboard', end: true },
      { to: '/app/attendances', icon: 'bi-clock-history', label: 'Kehadiran' },
      { to: '/app/publication', icon: 'bi-journal-text', label: 'Publikasi' },
    ],
  }[role];

  const roleProfilePath = role === 'student' ? '/app/profile' : `/${role}/profile`;

  return (
    <>
      <nav className='bottom-nav fixed-bottom d-lg-none bg-white border-top shadow-lg d-flex'>
        {primaryItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.disabled ? '#' : item.to}
            end={item.end}
            onClick={(e) => {
              if (item.disabled) e.preventDefault();
            }}
            className={({ isActive }) =>
              `bottom-nav-link${isActive && !item.disabled ? ' active' : ''}${item.disabled ? ' disabled' : ''}`
            }
          >
            <i className={`bi ${item.icon}`}></i>
            <span>{item.label}</span>
          </NavLink>
        ))}
        <button
          type='button'
          onClick={openMenu}
          className='bottom-nav-link'
        >
          <i className='bi bi-grid-3x3-gap-fill'></i>
          <span>Menu</span>
        </button>
      </nav>

      <div
        className='offcanvas offcanvas-bottom d-lg-none'
        tabIndex='-1'
        ref={offcanvasRef}
        style={{ height: 'auto', maxHeight: '75vh', borderRadius: '20px 20px 0 0' }}
      >
        <div className='offcanvas-header border-bottom'>
          <h6 className='offcanvas-title fw-bold'>Menu</h6>
          <button
            type='button'
            className='btn-close'
            data-bs-dismiss='offcanvas'
            aria-label='Close'
          ></button>
        </div>
        <div className='offcanvas-body px-3 py-2'>
          {role === 'admin' && (
            <AdminSidebarLinks authUser={authUser} isCollapsed={false} />
          )}
          {role === 'mentor' && <MentorSidebarLinks isCollapsed={false} />}
          {role === 'bumdes' && (
            <BumdesSidebarLinks authUser={authUser} isCollapsed={false} />
          )}
          {role === 'dpl' && <DplSidebarLinks isCollapsed={false} />}
          {role === 'student' &&
            studentMenuItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive
                    ? 'sidebar-link active text-decoration-none'
                    : 'sidebar-link link-body-emphasis text-decoration-none'
                }
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </NavLink>
            ))}

          <hr className='my-2' />

          <NavLink
            to={roleProfilePath}
            className={({ isActive }) =>
              isActive
                ? 'sidebar-link active text-decoration-none'
                : 'sidebar-link link-body-emphasis text-decoration-none'
            }
          >
            <i className='bi bi-person'></i>
            <span>Profile</span>
          </NavLink>
          <button
            type='button'
            onClick={signOut}
            className='sidebar-link text-decoration-none text-danger border-0 bg-transparent w-100 text-start'
          >
            <i className='bi bi-box-arrow-right'></i>
            <span>Sign out</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileBottomNav;
